import { DedicatedWorkerReportActionTypes, DedicatedWorkerReportState, READ_DEDICATED_WORKER_REPORT_DATA_REQUEST, READ_DEDICATED_WORKER_REPORT_DATA_SUCCESS, READ_DEDICATED_WORKER_REPORT_DATA_FAILURE } from "store/reducers/types/dashboard/dedicatedWorkerReport";

const defaultState: DedicatedWorkerReportState = {
  isLoading: false,
  errorMessage: "",
};

export default function dedicatedWorkerReport(state = defaultState, action: DedicatedWorkerReportActionTypes): DedicatedWorkerReportState {
  switch (action.type) {
    case READ_DEDICATED_WORKER_REPORT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_DEDICATED_WORKER_REPORT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_DEDICATED_WORKER_REPORT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
